import Marquee from "react-fast-marquee";
import { Asterisk } from "@phosphor-icons/react";

const ITEMS = [
  "Manager Development",
  "Workplace Skills Labs",
  "HR Consulting",
  "Operations Consulting",
  "Better Managers. Stronger Teams.",
];

const EditorialMarquee = () => (
  <section data-testid="editorial-marquee" className="bg-cream py-8 md:py-10 border-y border-black/5 overflow-hidden">
    <Marquee speed={35} gradient={false} pauseOnHover>
      {ITEMS.map((item) => (
        <span key={item} className="flex items-center">
          <span className="font-serif italic text-2xl md:text-4xl text-ink px-6 md:px-10 whitespace-nowrap">
            {item}
          </span>
          <Asterisk size={26} weight="bold" className="text-terracotta shrink-0" />
        </span>
      ))}
    </Marquee>
  </section>
);

export default EditorialMarquee;
